<div fxLayout="column" fxLayoutAlign="space-between start">
  <h1 class="header">
    Wydatek odczytany
  </h1>
  <p class="font-medium" style="margin-top: 0; margin-bottom: 2rem">
    Sprawdź poprawność danych
  </p>
</div>

<form *ngIf="form" [formGroup]="form" class="flex flex-col">
  <mat-form-field appearance="outline" class="flex-1 large-spacing">
    <mat-label>Dostawca</mat-label>

    <input
      [formControl]="form.biller"
      matInput
      type="text"
      name="biller"
      autocomplete="auto"
      tabindex="0"
      appGtmFormEvent
      [eventField]="'biller'"
      disabled="true">
  </mat-form-field>

  <mat-form-field appearance="outline" class="large-spacing">
    <mat-label>Nr rachunku</mat-label>
    <input
      [formControl]="form.bban"
      matInput
      type="text"
      name="bban"
      mask="00 0000 0000 0000 0000 0000 0000"
      inputmode="numeric"
      autocomplete="off"
      tabindex="0"
      appGtmFormEvent
      [eventField]="'bban'"
      disabled="true"
    />
    <mat-error *ngIf="form.bban.errors">Nieprawidłowy numer konta</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="large-spacing">
    <mat-label>Kwota</mat-label>
    <input
      [formControl]="form.amount"
      matInput
      type="text"
      name="amount"
      appCurrency
      autocomplete="off"
      tabindex="0"
    />
    <mat-error>
      <app-amount-error
        disabled="true"
        [amount]="form.amount"
        [minAmount]="MIN_AMOUNT"
        [maxAmount]="this.appConfig.config.liabilityAmountLimit"
      ></app-amount-error>
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="outline" class="large-spacing">
    <mat-label>Tytuł</mat-label>
    <div class="flex  justify-start">
      <input
        matInput
        [formControl]="form.title"
        [maxlength]="this.appConfig.config.titleMaxLength"
        [appInputMaxLength]="this.appConfig.config.titleMaxLength"
        name="title"
      />
      <app-icon
        name="info_outlined"
        size="20"
        matTooltip="Tytuł powinien pozwalać na identyfikację wpłaty przez dostawcę."
      ></app-icon>
    </div>
    <mat-hint align="end"
    >{{ form.get('title').value?.length || 0 }} / {{ this.appConfig.config.titleMaxLength }}
    </mat-hint
    >
    <mat-error *ngIf="form.title.errors?.required"> Uzupełnij tytuł</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="large-spacing">
    <mat-label>Termin płatności</mat-label>
    <input
      appInputDateMask
      [formControl]="form.paymentDue"
      matInput
      [matDatepicker]="paymentDue"
      autocomplete="off" />
    <mat-datepicker-toggle matSuffix [for]="paymentDue"></mat-datepicker-toggle>
    <mat-datepicker #paymentDue></mat-datepicker>
  </mat-form-field>
  <div class="flex flex-col">
    <div class="flex flex-row">
      <button type="button" mat-button class="self-center font-bold font-medium primary-color"
              style="width: 250px; height: 48px !important; align-self: baseline; padding-top: 0;"
              (click)="onModifyClick()">
        Modyfikuj
      </button>
      <app-new-loader-button
        class="big-button button-250 self-center"
        color="accent"
        [loading]="saving"
        [customType]="LoaderButtonType.RAISED"
        cdkFocusInitial
        buttonType="submit"
        [appApiCallLoading]="submit"
      >
        Potwierdź
      </app-new-loader-button>
    </div>
    <button type="button" mat-button class="self-center font-bold font-medium primary-color "
            style="width: 250px;" routerLink="../">
      Wróć
    </button>
  </div>
</form>
